export default "__VITE_ASSET__BhaetdIW__"